import OnBoardingLayout from "../OnBoardingLayout.jsx";
import FormContainer from "../../../../components/form/FormContainer.jsx";
import FormControl from "../../../../components/form/FormControl.jsx";
import {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import FormButton from "../../../../components/form/FormButton.jsx";
import useDownloadState from "../../../../api/utilities/useDownloadState.js";
import FormError from "../../../../components/form/FormError.jsx";
import LoadingComponent from "../../../../components/LoadingComponent.jsx";
import {ProjectApi, UserApi} from "../../../../api/authority/generated/index.ts";
import {GlobalContext} from "../../../../utils/context/GlobalContextProvider.jsx";
import Button from "../../../../components/Button.jsx";
import {useNavigate} from "react-router-dom";

export default function AccountNameStep() {

    let {t} = useTranslation();

    let navigate = useNavigate();

    let {
        context,
        getAuthorityConfiguration,
        resetCurrentUserProjects,
        setCurrentProjectId,
        updateIdentityUser
    } = useContext(GlobalContext);

    let billingAccount = null;

    for (let project of context.currentUserProjects) {
        if (project.billingAccount) {
            billingAccount = project.billingAccount;
        }
    }

    /** @var {BillingAccountInput} billingAccountInput */
    let [billingAccountInput, setBillingAccountInput] = useState({
        firstName: context.currentIdentity?.user?.firstName ?? '',
        lastName: context.currentIdentity?.user?.lastName ?? '',
    });

    let [creatingState, setCreatingDownloading, setCreatingResult, setCreatingError] = useDownloadState();
    let [updatingState, setUpdatingDownloading, setUpdatingResult, setUpdatingError] = useDownloadState();
    let [createPressed, setCreatePressed] = useState(false);

    useEffect(() => {

        if (!createPressed) {
            return;
        }

        setCreatePressed(false);
        setCreatingDownloading(true);

        new UserApi(getAuthorityConfiguration())
            .updateProfile({
                userId: context.currentIdentity?.user.id,
                userProfileInput: {
                    firstName: billingAccountInput.firstName,
                    lastName: billingAccountInput.lastName,
                }
            })
            .then((r) => {
                updateIdentityUser(r);
                navigate('/');
            })
            .catch(() => {
            })
            .finally(() => {
            });

    }, [createPressed]);

    return (
        <OnBoardingLayout>
            <FormContainer>
                <LoadingComponent loading={creatingState.downloading || updatingState.downloading || createPressed}>
                    {creatingState.error && <FormError error={creatingState.error}/>}
                    <FormControl
                        label={t('user.first-name')}
                        value={billingAccountInput.firstName}
                        onChange={(e) => setBillingAccountInput({
                            ...billingAccountInput,
                            firstName: e.target.value
                        })}
                    />
                    <FormControl
                        className={'mt-3'}
                        label={t('user.last-name')}
                        value={billingAccountInput.lastName}
                        onChange={(e) => setBillingAccountInput({...billingAccountInput, lastName: e.target.value})}
                    />
                    <FormButton
                        className={'button-primary mt-2'}
                        onClick={() => setCreatePressed(true)}
                    >
                        {t('onboarding.next-step')}
                    </FormButton>
                </LoadingComponent>
            </FormContainer>
        </OnBoardingLayout>
    );
}
